// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  staticqrDetails: Object,
};

const DeleteStaticQR = (props: Props) => {
  const {
    visible,
    close,
    submit,
    staticqrDetails,
  } = props;

  const DeleteQR = () => {
    submit(staticqrDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={DeleteQR} type="danger">Delete</SpButton>,
      ]}
      title="Delete Static QR"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this static qr?</div>
        <SpH5 className="pb-3">
          <div>
            {(staticqrDetails.staticQrAccount && staticqrDetails.staticQrAccount.account && staticqrDetails.staticQrAccount.account.name)
              || <>&#8211;</>}
          </div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteStaticQR;
